import { render } from "./CalculatingPage.vue?vue&type=template&id=e96e100a&scoped=true"
import script from "./CalculatingPage.vue?vue&type=script&lang=js"
export * from "./CalculatingPage.vue?vue&type=script&lang=js"

import "./CalculatingPage.vue?vue&type=style&index=0&id=e96e100a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e96e100a"]])

export default __exports__